import { render, staticRenderFns } from "./AgregarConsentimientos.vue?vue&type=template&id=0f56afe7"
import script from "./AgregarConsentimientos.vue?vue&type=script&lang=js"
export * from "./AgregarConsentimientos.vue?vue&type=script&lang=js"
import style0 from "./AgregarConsentimientos.vue?vue&type=style&index=0&id=0f56afe7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports